import Link from 'next/link';
import { UIEdit, UIMenuSection, UISandboxMenuSection } from '@creoate/virgo-content-api';

// mui
import Button from '@mui/material/Button';
import type { SxProps, Theme } from '@mui/system';

// utils
import { TProps } from '../utils/types';

const navLinkStyles = (isHighlighted: boolean, isActive: boolean): SxProps<Theme> => ({
  borderRadius: 0,
  textAlign: 'center',
  textTransform: 'none',
  borderBottom: '3px solid transparent',
  color: isHighlighted ? 'red' : 'inherit',
  '&:hover': {
    color: isHighlighted ? 'white' : 'rgba(73, 114, 98, 1)',
    backgroundColor: isHighlighted ? 'red' : 'rgba(116, 155, 141, 0.04)',
    borderBottomColor: isHighlighted ? 'red' : 'rgba(73, 114, 98, 1)',
  },
  ...(isActive && {
    color: isHighlighted ? 'white' : 'rgba(73, 114, 98, 1)',
    backgroundColor: isHighlighted ? 'red' : 'rgba(116, 155, 141, 0.04)',
    borderBottomColor: isHighlighted ? 'red' : 'rgba(73, 114, 98, 1)',
  }),
});

const NavLink = ({ menuItem, hoveredNavLinkItem, handlePopover, index }: TProps) => {
  if (!menuItem) return null;

  const { isHighlighted, component } = menuItem;
  const commonProps = {
    sx: navLinkStyles(isHighlighted, hoveredNavLinkItem?.index === index),
    component: Link,
    className: 'top-menu-link',
    'data-testid': `desktop-top-menu-links-wrapper-item-${hoveredNavLinkItem?.label}`,
  };

  if (component === 'ui.menu-section') {
    const { link, label } = menuItem as UIMenuSection;
    return (
      <Button
        {...commonProps}
        href={link?.url || '#'}
        children={label}
        onMouseEnter={() => handlePopover({ index, component, label })}
      />
    );
  }

  if (component === 'ui.sandbox-menu-section') {
    const { label, url } = menuItem as UISandboxMenuSection;
    return (
      <Button
        {...commonProps}
        href={url || '#'}
        children={label}
        onMouseEnter={() => handlePopover({ index, component, label })}
      />
    );
  }

  const { link } = menuItem as UIEdit;
  return (
    <Button
      {...commonProps}
      href={link?.url || '#'}
      children={link?.label}
      onMouseEnter={() => handlePopover({ index, component, label: link?.label })}
    />
  );
};

export default NavLink;
